module.exports = __webpack_public_path__ + "img/btn-AMGH.afcf8cb0.png";